import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

// Components
import ScrollToTop from "@/components/ScrollToTop";

// Pages
import HomePage from "@/pages/HomePage";
import GalleryPage from "@/pages/GalleryPage";
import AmenitiesPage from "@/pages/AmenitiesPage";
import PricingPage from "@/pages/PricingPage";
import BookingPage from "@/pages/BookingPage";
import FAQPage from "@/pages/FAQPage";
import ContactPage from "@/pages/ContactPage";
import LocationPage from "@/pages/LocationPage";
import LinksPage from "@/pages/LinksPage";
import ThingsToDoPage from "@/pages/ThingsToDoPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import ContractPage from "@/pages/ContractPage";

// Context
import { AuthProvider } from "@/context/AuthContext";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/amenities" element={<AmenitiesPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/booking" element={<BookingPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/location" element={<LocationPage />} />
            <Route path="/links" element={<LinksPage />} />
            <Route path="/things-to-do" element={<ThingsToDoPage />} />
            <Route path="/contract/:token" element={<ContractPage />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin/*" element={<AdminDashboard />} />
            {/* Catch-all route: redirect any 404/unknown paths to homepage */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-right" richColors />
      </div>
    </AuthProvider>
  );
}

export default App;
